// client/src/components/ErrorFallback.jsx
import { Container, Button, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaHome, FaRedo, FaExclamationTriangle } from 'react-icons/fa';
import './ErrorFallback.css';

const ErrorFallback = ({ error, errorInfo, resetError }) => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    resetError();
    navigate('/');
  };

  const handleReload = () => {
    resetError();
    window.location.reload();
  };

  const isDevelopment = process.env.NODE_ENV === 'development';

  return (
    <Container className="error-fallback-container">
      <div className="error-fallback-content">
        {/* Error Icon */}
        <div className="error-fallback-icon">
          <FaExclamationTriangle />
        </div>

        {/* Error Title */}
        <h1 className="error-fallback-title">Oops! Something went wrong</h1>

        {/* Error Message */}
        <p className="error-fallback-message">
          We're sorry, but something unexpected happened. Don't worry, your data is safe.
        </p>

        {/* Action Buttons */}
        <div className="error-fallback-actions">
          <Button
            variant="primary"
            size="lg"
            onClick={handleReload}
            className="error-fallback-btn"
          >
            <FaRedo className="me-2" />
            Reload Page
          </Button>

          <Button
            variant="outline-primary"
            size="lg"
            onClick={handleGoHome}
            className="error-fallback-btn"
          >
            <FaHome className="me-2" />
            Go to Homepage
          </Button>
        </div>

        {/* Development-only error details */}
        {isDevelopment && error && (
          <Alert variant="danger" className="error-fallback-details mt-4">
            <Alert.Heading>Error Details (Development Only)</Alert.Heading>
            <div className="error-details-content">
              <strong>Error:</strong>
              <pre className="error-message-pre">{error.toString()}</pre>

              {errorInfo && (
                <>
                  <strong>Component Stack:</strong>
                  <pre className="error-stack-pre">{errorInfo.componentStack}</pre>
                </>
              )}
            </div>
          </Alert>
        )}

        {/* Help Text */}
        <div className="error-fallback-help">
          <p>
            If this problem persists, please contact our support team.
          </p>
        </div>
      </div>
    </Container>
  );
};

export default ErrorFallback;
